import React from 'react'

import winItImage from '../../../public/static/images/svg/fetcher/winItShadow.svg'

const WinItLogo = (props) => {
  return (
    <img src={winItImage} style={{paddingTop: '1rem'}}/>
  )
}

export default WinItLogo
